export const BackendUrl = 'https://ai-in-telegram-control-panel-bot-backend.ru/app1'